export default {
  staleImageError: {
    title: 'Zastaraný snímok',
    description: 'Snímok z kamery je zastaraný (neaktuálny)',
  },
};
